type keyboardShortcuts = { [category: string]: Array<keyboardShortcutObj> };

type keyboardShortcutObj = {
  keys: Array<string>;
  description: string;
};

const KeyByLayout = (key: string) => {
  const isMac = navigator.userAgent.includes("Macintosh");
  switch (key) {
    case "Control":
      return isMac ? "Cmd" : "Ctrl";
    case "Alt":
      return isMac ? "Option" : "Alt";
    default:
      return key;
  }
};
const contentControlStudioKeyboardShortcuts: keyboardShortcuts = {
  "Playback Controls": [
    {
      keys: ["k"],
      description: "Play/Pause video",
    },
    {
      keys: ["M"],
      description: "Toggle Audio",
    },
    {
      keys: [KeyByLayout("Shift"), "↑"],
      description: "Increase playback speed by 10%",
    },
    {
      keys: [KeyByLayout("Shift"), "↓"],
      description: "Decrease playback speed by 10%",
    },
    {
      keys: [KeyByLayout("Shift"), "Backspace"],
      description: "Set playback speed to it's default value",
    },
  ],
  "Navigation Controls": [
    {
      keys: ["←"],
      description: "Step back 1 frame",
    },
    {
      keys: [KeyByLayout("Shift"), "←"],
      description: "Step back 5 frames",
    },
    {
      keys: ["→"],
      description: "Step forward 1 frame",
    },
    {
      keys: [KeyByLayout("Shift"), "→"],
      description: "Step forward 5 frames",
    },
    {
      keys: ["Page Up"],
      description: "Go to next keyframe in selected event",
    },
    {
      keys: ["Page Down"],
      description: "Go to previous keyframe in selected event",
    },
  ],
  Edit: [
    {
      keys: [KeyByLayout("Control"), "z"],
      description: "Undo action",
    },
    {
      keys: [KeyByLayout("Shift"), KeyByLayout("Control"), "z"],
      description: "Redo action",
    },
    {
      keys: ["Escape"],
      description: "Unselect selected event",
    },
    {
      keys: ["Delete"],
      description: "Delete current keyframe in selected event",
    },
    {
      keys: [KeyByLayout("Control"), "s"],
      description: "Save changes",
    },
  ],
  Sequence: [
    { keys: ["+"], description: "Zoom in" },
    { keys: ["-"], description: "Zoom out" },
    {
      keys: [KeyByLayout("Shift"), "1"],
      description: "Zoom to fit",
    },
    {
      keys: [KeyByLayout("Shift"), "2"],
      description: "Zoom to event",
    },
  ],
  Markers: [
    {
      keys: ["I"],
      description: "Mark IN",
    },
    {
      keys: ["O"],
      description: "Mark OUT",
    },
    {
      keys: [KeyByLayout("Shift"), "I"],
      description: "Go to start of event/video",
    },
    {
      keys: [KeyByLayout("Shift"), "O"],
      description: "Go to end of event/video",
    },
  ],
};

const clippingStudioKeyboardShortcuts: keyboardShortcuts = {
  "Playback Controls": [
    { keys: ["k"], description: "Play/Pause video" },
    { keys: ["Space"], description: "Play/Pause video" },
    { keys: ["M"], description: "Toggle audio" },
    {
      keys: [KeyByLayout("Shift"), "↑"],
      description: "Increase playback speed by 10%",
    },
    {
      keys: [KeyByLayout("Shift"), "↓"],
      description: "Decrease playback speed by 10%",
    },
    {
      keys: [KeyByLayout("Shift"), "Backspace"],
      description: "Set playback speed to its default value",
    },
  ],
  "Navigation Controls": [
    { keys: ["←"], description: "Step back 1 frame" },
    { keys: ["→"], description: "Step forward 1 frame" },
    {
      keys: [KeyByLayout("Shift"), "I"],
      description: "Go to IN point",
    },
    {
      keys: [KeyByLayout("Shift"), "O"],
      description: "Go to OUT point",
    },
  ],
  Edit: [
    { keys: [KeyByLayout("Control"), "z"], description: "Undo action" },
    {
      keys: [KeyByLayout("Shift"), KeyByLayout("Control"), "z"],
      description: "Redo action",
    },
    { keys: [KeyByLayout("Control"), "s"], description: "Save project" },
    { keys: ["Escape"], description: "Unselect selected event" },
    { keys: ["Delete"], description: "Delete selected clip or marker" },
  ],
  Markers: [
    { keys: ["I"], description: "Mark IN" },
    { keys: ["O"], description: "Mark OUT" },
  ],
  Sequence: [
    { keys: ["+"], description: "Zoom in" },
    { keys: ["-"], description: "Zoom out" },
    {
      keys: [KeyByLayout("Shift"), "1"],
      description: "Zoom to fit",
    },
    {
      keys: [KeyByLayout("Shift"), "2"],
      description: "Zoom to segment",
    },
  ],
};

export {
  keyboardShortcuts as KeyboardShortcuts,
  keyboardShortcutObj as KeyboardShortcutObj,
  contentControlStudioKeyboardShortcuts as ContentControlStudioKeyboardShortcuts,
  clippingStudioKeyboardShortcuts as ClippingStudioKeyboardShortcuts,
};
